import { combineReducers } from 'redux'
import createOrg, { initialState as createOrgInitialState } from './create-org'
import createUser, {
  initialState as createUserInitialState,
} from './create-user'
import expired, { initialState as expiredInitialState } from './expired'
import inviteUsers, {
  initialState as inviteUsersInitialState,
} from './invite-users'
import link, { initialState as linkInitialState } from './link'
import login, { initialState as loginInitialState } from './login'
import password, { initialState as passwordInitialState } from './password'
import sso, { initialState as ssoInitialStage } from './sso'
import username, { initialState as usernameInitialState } from './username'
import verifyPhone, {
  initialState as verifyPhoneInitialState,
} from './verify-phone'

import general, { initialState as generalInitialState } from './general'
import github, { initialState as githubInitialState } from './github'

import { reducer as form } from 'redux-form'

const reducers = {
  general,
  github,
  createOrg,
  createUser,
  expired,
  inviteUsers,
  link,
  login,
  password,
  sso,
  username,
  verifyPhone,
  form,
}

export const initialState = {
  general: generalInitialState,
  github: githubInitialState,
  createOrg: createOrgInitialState,
  createUser: createUserInitialState,
  expired: expiredInitialState,
  inviteUsers: inviteUsersInitialState,
  link: linkInitialState,
  login: loginInitialState,
  password: passwordInitialState,
  sso: ssoInitialStage,
  username: usernameInitialState,
  verifyPhone: verifyPhoneInitialState,
}

export default combineReducers(reducers)
